/**
 * Query keys allowed in URLs sent to GA4 (page_location, page_path, landing_path).
 * Everything else — including free text such as the cost tool `estimate_summary` — is dropped.
 */
export const ANALYTICS_QUERY_ALLOWLIST = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'source',
  'tool_id',
  'project_type',
] as const;

const ALLOWED_KEYS = new Set<string>(ANALYTICS_QUERY_ALLOWLIST);
const MAX_PARAM_VALUE_CHARS = 100;

/**
 * Strip fragment and non-allowlisted query params. Accepts a path (`/contact?x=1`)
 * or an absolute URL; returns the same shape it received.
 */
export function sanitizeAnalyticsUrl(value: string | null | undefined): string {
  const raw = value?.trim();
  if (!raw) return '';

  const isAbsolute = /^[a-z][a-z\d+.-]*:\/\//i.test(raw);
  let url: URL;
  try {
    url = new URL(raw, 'https://placeholder.invalid');
  } catch {
    return '';
  }

  const kept = new URLSearchParams();
  url.searchParams.forEach((paramValue, key) => {
    if (ALLOWED_KEYS.has(key)) kept.append(key, paramValue.slice(0, MAX_PARAM_VALUE_CHARS));
  });
  const query = kept.toString();
  const pathWithQuery = `${url.pathname}${query ? `?${query}` : ''}`;

  return isAbsolute ? `${url.origin}${pathWithQuery}` : pathWithQuery;
}
